<template>
  <div class="login-screen">
    <div class="login-card">
      <img class="logo" src="/dbi-logo.svg" alt="Deep Breath Intelligence" />

      <form @submit.prevent="onSubmit">
        <label class="lbl" for="login-email">Email</label>
        <div class="field">
          <font-awesome-icon icon="envelope" class="ico" />
          <input
            id="login-email"
            v-model="form.email"
            type="email"
            placeholder="Email Address"
            autocomplete="username"
            data-cypress="login.email"
          />
        </div>

        <label class="lbl" for="login-password">Password</label>
        <div class="field">
          <font-awesome-icon icon="lock" class="ico" />
          <input
            id="login-password"
            v-model="form.password"
            type="password"
            placeholder="Password"
            autocomplete="current-password"
            data-cypress="login.password"
          />
        </div>

        <p v-if="error" class="err" data-cypress="login.error">{{ error }}</p>

        <div class="actions">
          <button
            class="btn"
            type="submit"
            :disabled="loading"
            data-cypress="login.submit"
          >
            {{ loading ? 'SIGNING IN…' : 'SIGN IN' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { actionTypes, getterTypes } from 'store/auth'
import { appStartRoute } from '@/router'

export default {
  name: 'Login',
  data() {
    return { form: { email: '', password: '' } }
  },
  computed: {
    ...mapGetters({ error: getterTypes.error, status: getterTypes.status }),
    loading() {
      return this.status === 'loading'
    },
  },
  methods: {
    async onSubmit() {
      try {
        await this.$store.dispatch(actionTypes.login, { ...this.form })
        this.$router.push(this.$route.query.redirect || { name: appStartRoute })
      } catch (e) {
        /* error surfaced via store getter */
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.login-screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #8a72c8 0%, #6f55b1 100%);
  // subtle topographic wave texture, matching the original
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='28'%3E%3Cpath d='M0 14 Q 40 2 80 14 T 160 14' fill='none' stroke='rgba(255,255,255,0.06)' stroke-width='2'/%3E%3C/svg%3E"),
    linear-gradient(135deg, #8a72c8 0%, #6f55b1 100%);
}

.login-card {
  width: 100%;
  max-width: 440px;
  margin: 1rem;
  padding: 2.5rem 2.5rem 2rem;
  background: #e9e4f4;
  border-radius: 14px;
  box-shadow: 0 18px 50px rgba(40, 20, 80, 0.35);
}

.logo {
  display: block;
  width: 260px;
  max-width: 82%;
  height: auto;
  margin: 0 auto 2rem;
}

.lbl {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #5b5475;
}

.field {
  position: relative;
  margin-bottom: 1.25rem;

  .ico {
    position: absolute;
    left: 0.85rem;
    top: 50%;
    transform: translateY(-50%);
    color: #8a7db5;
  }

  input {
    width: 100%;
    padding: 0.72rem 0.9rem 0.72rem 2.4rem;
    background: #f4f1fb;
    border: 1px solid #ddd6ee;
    border-radius: 8px;
    font-weight: 600;
    color: #3a3357;

    &::placeholder {
      color: #b5acce;
      font-weight: 500;
    }
    &:focus {
      outline: none;
      border-color: #8b5cf6;
      box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.2);
    }
  }
}

.err {
  margin: 0.25rem 0 0;
  color: #dc2626;
  font-size: 0.8rem;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.btn {
  padding: 0.7rem 1.9rem;
  background: #8a1fd4;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.05em;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #7a18bd;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
